export const ROOT_ELEMENT_ID = 'root';
export const TOP_MENU_ID = 'topMenu';
export const LEFT_MENU_ID = 'leftMenu';
